import React, { ReactNode, useMemo } from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import Button from 'carbon-react/lib/components/button';
import { Card } from 'carbon-react/lib/components/card';
import Typography from 'carbon-react/lib/components/typography';

interface SfaConnectionProviderProps {
  icon: ReactNode;
  name: string;
  onConnect: () => void;
  connectTextOverride?: ReactNode;
}

export const SfaConnectionProvider = ({ icon, name, onConnect, connectTextOverride }: SfaConnectionProviderProps) => {
  const intl = useIntl();
  const text = useMemo(
    () => ({
      connect: intl.formatMessage({
        id: 'common.connect',
        defaultMessage: 'Connect'
      })
    }),
    [intl]
  );

  return (
    <Card margin={0} mb={1} width="100%">
      <Box display="flex" pb={3}>
        <Box display="flex" alignItems="center" width="100%" justifyContent="flex-start" mt={3}>
          {icon}
          <Typography variant="segment-header-small" fontSize="16px" mx={3} textAlign="left">
            {name}
          </Typography>
          <Button type="button" onClick={onConnect} ml="auto">
            {connectTextOverride || text.connect}
          </Button>
        </Box>
      </Box>
    </Card>
  );
};
